import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

import ModalFrame	from '../common/_ModalFrame.jsx';
import moment 		from 'moment';

import DownloadNav from './_DownloadNav.jsx';

const mac_dl_link 		= ("https://studio.download.bricklink.info/PartDesigner/PartDesigner.pkg");
const win_dl_link_32bit = ("https://studio.download.bricklink.info/PartDesigner/PartDesigner_32.exe");
const win_dl_link_64bit = ("https://studio.download.bricklink.info/PartDesigner/PartDesigner.exe");

export default class PartDesigner extends BLComponent 
{
	constructor (props) {
		super(props);

		this.state = {
			featureView: 1,
			emailAddress: '',
			changeLog: blapp.models.get('changeLog'),
			latestLogVersion: blapp.models.get('changeLog').reverse()[0].strVersion,
			os: 		this.getClientOS(),
			version: 	this.getClientVersion(),
		};
	}

	componentDidMount() {
		this.setState({ selectedLogVersion : this.state.latestLogVersion})
	}

	render() {
		return (
			<main className="main main--white">
				<div className="main__content">
					<DownloadNav page={2}/>
					<div className="edge-to-edge-container partdesigner__container">
						<div className="edge-to-edge-container__internal">
							{this.renderIntro()}
							{this.renderFeatures()}
							{this.renderFooter()}
						</div>
					</div>
					{this.renderChangeLog()}
				</div>
			</main>
		);
	}

	renderIntro() {
		return (
			<div className="edge-to-edge-container">
				<div className="edge-to-edge-container__internal">
					<section className="partdesigner__header">
						<div className="partdesigner__header-text">
							<h1 className="text--uppercase page-title text-color--white">Maximize your creativity with PartDesigner!<span className="pill pill--red pill--tight text--normal partdesigner__header-pill">Beta</span></h1>
						</div>
						<div className="partdesigner__header-image">
							<div className="partdesigner__header-image-item">
								<img src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/header.png"} alt="Custom Bob Ross minifig infront of iMac showing PartDesigner" className="l-block"/>
							</div>
						</div>
						<div className="partdesigner__header-cta">
							{this.renderDownloadButton()}
						</div>
					</section>
				</div>
			</div>
		);
	}

	renderFeatures() {
		return (
			<div className="edge-to-edge-container partdesigner__features-container">
				<div className="edge-to-edge-container__internal">
					<section className="partdesigner__features">
						<div className={"partdesigner__features-item" + (this.state.featureView == 1 ? ' partdesigner__features-item--active' : '')}>
							<h3 className="partdesigner__features-item-title section-title text--uppercase l-margin-bottom--sm" onClick={() => this.setState({featureView: 1})}>Create decal parts <i className={"l-hide--desktop l-margin-left--sm far fa-" + (this.state.featureView == 1 ? 'minus' : 'plus')}/></h3>
							<p className="partdesigner__features-item-details">It's just like adding stickers on plain parts in real life.</p>
							<p className="l-margin-bottom--xl partdesigner__features-item-details">Add images where you want to create custom decal parts.</p>
							<div>
								<img className="partdesigner__features-item-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/create-minifig.png"} alt="Adding decals to parts of a minifig"/>
							</div>
						</div>
						<div className={"partdesigner__features-item" + (this.state.featureView == 2 ? ' partdesigner__features-item--active' : '')}>
							<h3 className="partdesigner__features-item-title section-title text--uppercase l-margin-bottom--sm" onClick={() => this.setState({featureView: 2})}>Direct export to Studio<i className={"l-hide--desktop l-margin-left--sm far fa-" + (this.state.featureView == 2 ? 'minus' : 'plus')}/></h3>
							<p className="partdesigner__features-item-details">Directly export custom parts to Studio and find them in the Custom Palette.</p>
							<p className="l-margin-bottom--xl partdesigner__features-item-details">Add them in MOCs to beautifully decorate your designs.</p>
							<div>
								<img className="partdesigner__features-item-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/export-to-studio.png"} alt="PartDesigner screen with Studio screen on top showing freshly exported minifig"/>
							</div>
						</div>
						<div className={"partdesigner__features-item" + (this.state.featureView == 3 ? ' partdesigner__features-item--active' : '')}>
							<h3 className="partdesigner__features-item-title section-title text--uppercase l-margin-bottom--sm" onClick={() => this.setState({featureView: 3})}>Create &amp; edit parts<i className={"l-hide--desktop l-margin-left--sm far fa-" + (this.state.featureView == 3 ? 'minus' : 'plus')}/></h3>
							<p className="l-margin-bottom--xl partdesigner__features-item-details">Design your own parts. Drag to draw bricks, plates, or tiles. Merge, partially delete, or add accessories. Do some fun experiments in PartDesigner! </p>
							<div>
								<img className="partdesigner__features-item-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/draw-brick.gif"} alt="PartDesigner showing drawing of custom bricks"/>
							</div>
						</div>
						<div className={"partdesigner__features-item" + (this.state.featureView == 4 ? ' partdesigner__features-item--active' : '')}>
							<h3 className="partdesigner__features-item-title section-title text--uppercase l-margin-bottom--sm" onClick={() => this.setState({featureView: 4})}>Connectivity info<i className={"l-hide--desktop l-margin-left--sm far fa-" + (this.state.featureView == 4 ? 'minus' : 'plus')}/></h3>
							<p className="partdesigner__features-item-details">Parts don't snap? Or want to create conditional snapping points?</p>
							<p className="l-margin-bottom--xl partdesigner__features-item-details">In PartDesigner, you can add &amp; edit the connectivity info of all Studio parts.</p>
							<div>
								<img className="partdesigner__features-item-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/add-edit.gif"} alt="PartDesigner showing connectivity info of a part"/>
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	}

	renderFooter() {
		return (
			<div className="edge-to-edge-container partdesigner__footer-container">
				<div className="edge-to-edge-container__internal">
					<section className="partdesigner__footer">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/partdesigner/logo.png"} className="partdesigner__footer-logo" alt="PartDesigner logo"/>
						<p className="l-margin-bottom--xl">With PartDesigner, you can boost your creativity to create your ultimate design!</p>
						<a href="//forum.bricklink.com" className="btn btn--cta text--bold">Go to forum</a>
					</section>
				</div>
			</div>
		)
	}

	renderChangeLog() {
		let versions = {}
		this.state.changeLog.forEach( entry =>{
			if(versions[entry.patchYear] == null || versions[entry.patchYear] == 'undefined'){
				versions[entry.patchYear] = [ {month: moment(entry.patchMonth,'MM').format('MMMM'), day: entry.patchDay, version: entry.strVersion} ]
			}else{
				versions[entry.patchYear].push({month: moment(entry.patchMonth,'MM').format('MMMM'), day: entry.patchDay, version: entry.strVersion})
			}
		});

		const options = Object.keys(versions).reverse().map( (key) => {
			const patches = versions[key];
			return (
				<optgroup label={parseInt(key) + 2000} key={key}>
					{patches.map( patch => <option key={patch.version} value={patch.version}>{patch.month} {patch.day}</option>)}
				</optgroup>
			);
		});

		return (
			<div className="edge-to-edge-container bg-color--cloud">
				<div className="edge-to-edge-container__internal">
					<section className="studio-download__section l-pad-y--xl l-column">
						<div className="studio-download__changelog-head">
							<div className="page-title">Changelog</div>
							<select className="select select--tight studio-download__changelog-select" onChange={(e) => this.showChangeLog(e)}>
								{options}
							</select>
						</div>
						{this.renderChangeLogItem()}
					</section>
				</div>
			</div>
		);
	}

	renderChangeLogItem() {
		const logIndex = this.state.changeLog.findIndex(entry => entry.strVersion == this.state.selectedLogVersion);
		const log = this.state.changeLog[logIndex]
		return (
			log != null ?
			<div>
				<div className="l-flex l-split l-margin-bottom">
					<div>
						<strong className="section-title l-block l-margin-bottom--sm">Version {this.state.selectedLogVersion}</strong>
						<div className="text-color--grey">{moment(log.patchMonth,'MM').format('MMM')} {log.patchDay}, {parseInt(log.patchYear)+2000}</div>
					</div>
					<div className="text--right">
						{this.state.latestLogVersion == this.state.selectedLogVersion ?
							<div className="pill pill--green l-border-round text--uppercase l-flex-align-start text--bold l-margin-bottom">
								Latest version
							</div>
						: null}
						{/*this.renderDownloadInChangeLog()*/}
					</div>
				</div>
				<div>
					{log && log.listBugFixes.length > 0 ?
					<div className="l-margin-bottom">
						<strong className="l-block l-margin-bottom--sm">Bug fixes</strong>
						<ul className="bullet-list">
							{log.listBugFixes.map( (bug, idx) => <li key={idx}>{bug}</li>)}
						</ul>
					</div>
					: null}
					{log && log.listFeatures.length > 0 ?
					<div className="l-margin-bottom">
						<strong className="l-block l-margin-bottom--sm">Features</strong>
						<ul className="bullet-list">
							{log.listFeatures.map( (feat, idx) => <li key={idx}>{feat}</li>)}
						</ul>
					</div>
					: null}
					{log && log.listImprovements.length > 0 ?
					<div>
						<strong className="l-block l-margin-bottom--sm">Improvements</strong>
						<ul className="bullet-list">
							{log.listImprovements.map( (imp, idx) => <li key={idx}>{imp}</li>)}
						</ul>
					</div>
					: null}
				</div>
			</div>
			:null
		);
	}

	renderDownloadInChangeLog() {
		const selectedLogIndex 	= this.state.changeLog.findIndex(log => log.strVersion == this.state.selectedLogVersion);
		const selectedLog 			= this.state.changeLog[selectedLogIndex];
		const selectedFolder 		= `https://studio.download.bricklink.info/PartDesigner/Archive/${selectedLog.strVersion}`;

		return (
			<div className="build-studio__change-log-download text-color--grey l-flex l-hide--small">
				Download for: 
				<ul className="l-flex l-margin-left">
					<li className="l-margin-right--sm l-pad-right--sm l-border--right"><a onClick={()=>this.trackDownload( false, false )}  href={`${selectedFolder}/PartDesigner.pkg`}>Mac</a></li>
					<li className="l-margin-right--sm l-pad-right--sm l-border--right"><a onClick={()=>this.trackDownload( true, true )}  href={`${selectedFolder}/PartDesigner.exe`}>Win 32bit</a></li>
					<li><a onClick={()=>this.trackDownload( true, false )}  href={`${selectedFolder}/PartDesigner.exe`}>Win 64bit</a></li>
				</ul>
			</div>
		)
	}

	renderDownloadButton() {
		const isWindows = (this.state.os === 'Windows');
		const is32 			= (this.state.version === '32bit');

		if(isWindows){
			return (
				<div className="partdesigner__cta-block">
					<a onClick={() => this.trackDownload(true, is32)}href={is32 ? win_dl_link_32bit : win_dl_link_64bit} className="partdesigner__cta-btn studio-download__hero-cta">
						Downoad PartDesigner for Windows
					</a>
					<div className="partdesigner__cta-sub">
						<div className="l-margin-bottom">requires Windows 7 SP1+ or higher</div>
						<small>alternate versions:<a className="l-margin-left--sm" onClick={() => this.trackDownload(true, true)} href={win_dl_link_32bit}><i className="fab fa-windows l-margin-right--sm"></i>32bit</a><a className="l-margin-left--sm" onClick={() => this.trackDownload(true, false)} href={win_dl_link_64bit}><i className="fab fa-windows l-margin-right--sm"></i>64bit</a><a onClick={() => this.trackDownload(false, false)} className="l-margin-left--sm" href={mac_dl_link}><i className="fab fa-apple l-margin-right--sm"></i>Mac</a></small>
					</div>
				</div>
			);
		}else{
			return (
				<div className="partdesigner__cta-block">
					<a onClick={() => this.trackDownload(false, false)} href={mac_dl_link} className="partdesigner__cta-btn studio-download__hero-cta">
						Download PartDesigner for Mac
					</a>
					<div className="partdesigner__cta-sub">
						<div className="l-margin-bottom">requires High Sierra 10.13 or higher</div>
						<small>alternate versions:<a className="l-margin-left--sm" onClick={() => this.trackDownload(true, true)} href={win_dl_link_32bit}><i className="fab fa-windows l-margin-right--sm"></i>32bit</a><a className="l-margin-left--sm" onClick={() => this.trackDownload(true, false)} href={win_dl_link_64bit}><i className="fab fa-windows l-margin-right--sm"></i>64bit</a></small>
					</div>
				</div>
			);
		}
	}

	getClientOS() {
		let OSName = "Unknown OS";

		if(navigator.appVersion.indexOf("Win") != -1) {
			OSName = "Windows";
		}
		if(navigator.appVersion.indexOf("Mac") != -1) {
			OSName = "MacOS"
		};

		return OSName;
	}

	getClientVersion() {
		let version = "32bit";

		if(navigator.userAgent.indexOf("WOW64") != -1 || navigator.userAgent.indexOf("Win64") != -1) {
			version = "64bit";
		}else{
			version = "32bit";
		}

		return version;
	}

	showChangeLog(e)
	{
		this.setState({selectedLogVersion: e.target.value})
	}

	trackDownload(isWindows, is32)
	{
		if(!isWindows)
		{
			blapp.track.trackGeneral( 10052, "PartDesignerDownloadMac");
		}
		else
		{
			if(is32)
				blapp.track.trackGeneral( 10050, "PartDesignerDownloadWin32");
			else
				blapp.track.trackGeneral( 10051, "PartDesignerDownloadWin64");
		}
	}
}

document.addEventListener("DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<PartDesigner blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-studio-download' )
						);
		blapp.refs.register( "main", elem );
	}
);